/* Bluace Countdown — self-contained countdown logic.
   Supports multiple instances per page and Theme Editor reloads. */
(function () {
  'use strict';

  var timers = {};

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function computeDiff(endTime) {
    var remaining = endTime - Date.now();
    var ended = remaining <= 0;
    if (ended) remaining = 0;

    var totalSeconds = Math.floor(remaining / 1000);
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
      ended: ended
    };
  }

  function updateDisplay(root, diff) {
    var dayEl = root.querySelector('[data-bluace-days]');
    var hourEl = root.querySelector('[data-bluace-hours]');
    var minuteEl = root.querySelector('[data-bluace-minutes]');
    var secondEl = root.querySelector('[data-bluace-seconds]');

    if (dayEl) dayEl.textContent = pad(diff.days);
    if (hourEl) hourEl.textContent = pad(diff.hours);
    if (minuteEl) minuteEl.textContent = pad(diff.minutes);
    if (secondEl) secondEl.textContent = pad(diff.seconds);
  }

  function stopTimer(sectionId) {
    if (timers[sectionId]) {
      clearInterval(timers[sectionId]);
      delete timers[sectionId];
    }
  }

  function handleEnded(root) {
    var behavior = root.getAttribute('data-bluace-end-behavior');
    if (behavior === 'hide') {
      root.style.display = 'none';
      return;
    }
    var timerBlock = root.querySelector('[data-bluace-timer]');
    var endedMessage = root.querySelector('[data-bluace-ended-message]');
    if (timerBlock) timerBlock.style.display = 'none';
    if (endedMessage) endedMessage.style.display = 'flex';
  }

  function initCountdown(root) {
    if (!root || root.getAttribute('data-bluace-initialized') === 'true') return;

    var isoValue = root.getAttribute('data-bluace-end-iso') || '';
    var endTime = new Date(isoValue).getTime();
    if (isNaN(endTime)) return;

    var sectionId = root.getAttribute('data-bluace-section-id') || isoValue;
    root.setAttribute('data-bluace-initialized', 'true');

    function tick() {
      var diff = computeDiff(endTime);
      updateDisplay(root, diff);
      if (diff.ended) {
        handleEnded(root);
        stopTimer(sectionId);
      }
    }

    tick();
    stopTimer(sectionId);
    timers[sectionId] = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var context = scope || document;
    var nodes = context.querySelectorAll ? context.querySelectorAll('[data-bluace-countdown]') : [];
    for (var i = 0; i < nodes.length; i++) {
      initCountdown(nodes[i]);
    }
  }

  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-bluace-countdown]')
      : null;
    if (root) {
      var sectionId = root.getAttribute('data-bluace-section-id');
      stopTimer(sectionId);
    }
  });
})();